import { useCallback, useState } from 'react';
import type TrailId from '@alltrails/core/types/TrailId';
import { updateHideSummary } from '@alltrails/reviews/utils/reviewSummaryRequests';

type Args = {
  trailId?: TrailId;
  initialHideSummary?: boolean;
  initialReviewSummary?: string;
};

const useReviewSummary = ({ trailId, initialHideSummary, initialReviewSummary }: Args) => {
  const [isLoading, setIsLoading] = useState(false);
  const [hideSummary, setHideSummary] = useState(initialHideSummary);
  const [reviewSummary, setReviewSummary] = useState(initialReviewSummary);

  const onToggleHideSummary = useCallback(
    (newHideSummary: boolean) => {
      if (!trailId) {
        console.error('Trail ID is required to update hide summary');
        return;
      }

      setIsLoading(true);
      updateHideSummary(trailId, newHideSummary)
        .then(response => {
          setHideSummary(newHideSummary);
          setReviewSummary(response?.review_summary);
          setIsLoading(false);
        })
        .catch((e: Error) => {
          console.error(`Failed to update hide summary: ${e?.message}`);
          setIsLoading(false);
        });
    },
    [trailId]
  );

  return {
    isLoading,
    hideSummary,
    reviewSummary,
    onToggleHideSummary
  };
};

export default useReviewSummary;
